export const registerServiceWorker = () => {
  try {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/sw.js')
          .then((registration) => {
            // console.log('Service Worker registrado com sucesso:', registration);
          })
          .catch((error) => {
            console.log('Falha ao registrar o Service Worker:', error);
          });
      });
    }
  } catch (error) {

  }
};

// Função para enviar a mensagem para o Service Worker
export function toggleOfflineMode() {
  try {
    const forceOffline = localStorage.getItem("forceOffline") === "true";

  // Envia a mensagem para o Service Worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.active.postMessage({
        type: 'TOGGLE_OFFLINE',
        forceOffline: forceOffline,
      });
    });
  }
  } catch (error) {

  }
}

// Ouve a mudança no localStorage e altera o modo offline
window.addEventListener('storage', (event) => {
  if (event.key === "forceOffline") {
    toggleOfflineMode();  // Alterar o modo offline com base no novo valor
  }
});

export async function clearAllCaches() {
  if ('caches' in window) {
      try {
          // Obtém os nomes de todos os caches armazenados
          const cacheNames = await caches.keys();

          // Remove todos os caches iterando sobre os nomes
          await Promise.all(
              cacheNames.map(cacheName => caches.delete(cacheName))
          );
      } catch (error) {
          console.error('Erro ao limpar os caches:', error);
      }
  } else {
      console.warn('O Cache Storage não é suportado neste navegador.');
  }
}
